import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { FORM_FIELDS } from "../modal/helpers/constants";
import NewCategoryAdd from "./NewCategoryAdd";
import { FormStateProps } from "./ModalProductUpdate";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";
import { ProductType } from "../product";
import { capitalizeWords } from "../../helpers/format";

//coerce the usage of ProductTypes and ProductType into one with preference for the enum type

interface CategoryInterface extends FormStateProps {
  productType: ProductType;
}
export const Category = (props: CategoryInterface) => {
  const { formFields, setFields, productType } = props;
  const productState = useSelector((state: RootState) => state.Product);
  const [isNewCategory, setIsNewCategory] = useState(false);
  const categories =
    productType === ProductType.Drink
      ? productState.drinkCategories
      : productState.foodCategories;

  const categoryTranslation = useTranslation("category");
  const addNewCategoryTranslation = useTranslation("add_new_category");

  const selectChangeHandler = (value: string) => {
    if (value === FORM_FIELDS.CATEGORY.ADD_NEW) {
      setIsNewCategory(true);
    } else {
      setFields({ ...formFields, category: value });
    }
  };

  const hasCategories = !!categories.length;

  return (
    <Box sx={{ display: "grid", gap: 1 }}>
      <Box sx={{ minWidth: 120 }}>
        <FormControl sx={{ width: "100%" }} size="small">
          {!hasCategories && (
            <div style={{ color: "#f87171", fontSize: "12px" }}>
              Please add a category
            </div>
          )}
          <InputLabel
            id="demo-simple-select-standard-label"
            sx={{
              color: "#7a6560",
              fontSize: "12px",
              "&.Mui-focused": {
                color: "#9e4a50",
              },
            }}
          >
            {categoryTranslation}
          </InputLabel>
          <Select
            value={formFields.category}
            onChange={(e) => selectChangeHandler(e.target.value)}
            required
            label={categoryTranslation}
            sx={{
              borderRadius: "7px",
              bgcolor: "#1f1615",
              color: "#f0ece8",
              fontSize: "13px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(131, 60, 65, 0.18)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(158, 74, 80, 0.45)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#833c41",
              },
              "& .MuiSvgIcon-root": {
                color: "#7a6560",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: "#16100f",
                  color: "#f0ece8",
                  border: "1px solid rgba(131, 60, 65, 0.18)",
                },
              },
            }}
          >
            <MenuItem value={FORM_FIELDS.CATEGORY.ADD_NEW}>
              <em>-- {addNewCategoryTranslation} --</em>
            </MenuItem>
            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {capitalizeWords(category.name)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <NewCategoryAdd
        isAddMode={isNewCategory}
        setNewCategoryActive={setIsNewCategory}
        productAddType={productType}
      />
    </Box>
  );
};

export default Category;
